import React from 'react'
import { Link } from 'react-router-dom'
import qImg1 from '../../../images/icon/quote02.png'
import qImg2 from '../../../images/testimonial/da-img.png'
import qImg3 from '../../../images/brand/da-img.png'

const QuoteSetion = (props) => {

    const ClickHandler = (e) => {
        if (e) e.preventDefault();
    }
    return (
        <section className="quote&cta">
            <div className="container-fluid p-0">
                <div className="quote-wrapper ul_li">
                    <div className="da-quote">
                        <div className="xb-item--inner">
                            <span className="xb-item--quote"><img src={qImg1} alt=""/></span>
                            <p className="xb-item--content">“We build software for those who think differently. From Australia to the world — a small, precise team crafting products and platforms that last.”</p>
                            <div className="xb-item--holder ul_li">
                                <div className="xb-item--avatar">
                                    <h3 className="xb-item--name">Jyasa <span className="xb-item--desig">Boutique Software House</span></h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="da-cta">
                        <div className="xb-item--inner">
                            <h2 className="xb-item--title">Let’s build something worth building.</h2>
                            <p className="xb-item--content">Tell us about your project. We respond to every serious enquiry within one business day.</p>
                            <p className="xb-item--content mt-3"><a href="mailto:hello@jyasa.com" style={{color: 'inherit', textDecoration: 'underline'}}>hello@jyasa.com</a></p>
                            <div className="xb-btn mt-50">
                                <Link onClick={ClickHandler} to="/contact" className="thm-btn thm-btn--fill_icon thm-btn--data">
                                    <div className="xb-item--hidden"><span className="xb-item--hidden-text">Start a conversation</span></div>
                                    <div className="xb-item--holder">
                                        <span className="xb-item--text xb-item--text1">Start a conversation</span>
                                        <div className="xb-item--icon"><i className="fal fa-plus"></i></div>
                                        <span className="xb-item--text xb-item--text2">Start a conversation</span>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default QuoteSetion;